import {
  conteudoMinistradoDataStore
} from '../../../../../../../store/lancamento-aula/step-1/conteudo-ministrado-data.store';
import useFindTipoConteudoMinistrado
  from './hooks/use-find-tipo-conteudo-ministrado.hook';
import { useEffect } from 'react';

export default function useConteudoMinistradoForm() {
  const { conteudoMinistradoData } = conteudoMinistradoDataStore();
  const { tipoConteudoMinistrado, findTipoConteudoMinistrado } =
    useFindTipoConteudoMinistrado();

  const submitButtonDisabled = () => {
    const { conteudoDescricao, descricao } = conteudoMinistradoData;
    const conteudoVazio = conteudoDescricao?.trim() === '';
    const descricaoVazia = descricao?.trim() === '';

    return conteudoVazio || descricaoVazia;
  };

  useEffect(() => {
    const controller = new AbortController();

    findTipoConteudoMinistrado();

    return () => controller.abort();
  }, [findTipoConteudoMinistrado]);

  return {
    submitButtonDisabled: submitButtonDisabled(),
    tipoConteudoMinistrado
  };
}
